import { observer } from 'mobx-react-lite';
import BranchesListRow from './BranchesListRow';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';
import t360IntegrationStore from '~/view/screens/SettingsScreen/store/t360IntegrationStore';
import { LoadingStatus } from '~/types/main';
import { modalStore } from '~/mobx/modalStore';

const BranchesListBody: React.FC = observer(() => {
  const { takerAndToYouBranches, takerAndToYouBranchesLoadingStatus } = t360IntegrationStore;

  if (takerAndToYouBranchesLoadingStatus !== LoadingStatus.Success || !takerAndToYouBranches) {
    modalStore.closeToYouMatchBranchesModal();
    return null;
  }

  return (
    <ScrollableBlock showScrollbar scrollClassName="d-flex flex-column full-height px-8" className="flex-1 mb-3">
      {takerAndToYouBranches.taker_branches.map((takerBranch) => (
        <BranchesListRow key={`taker-branch-${takerBranch.id}`} takerBranch={takerBranch} />
      ))}
    </ScrollableBlock>
  );
});

export default BranchesListBody;
